import { invoiceNumberCorrelativo } from '../../invoice/invoiceNumberUtils';
import { gradeHeightGroupsFromLineas } from './gradeHeightRows';

function safe(s) {
  return s == null ? '' : String(s);
}

export function buildGradeHeightParams(api, opts = {}) {
  const numero =
    invoiceNumberCorrelativo(opts.numeroInvoice || api?.numero_invoice || '') || '';
  const groups = gradeHeightGroupsFromLineas(api?.lineas || []);
  return {
    numeroInvoice: numero,
    groups,
  };
}

export function gradeHeightFileBase(params) {
  const inv = safe(params?.numeroInvoice).replace(/\W/g, '_') || 'export';
  return `Grade_Height_${inv}`;
}
